/**
 * Created by snow on 2017/5/24.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import user from './model/useInfor'
import control from './model/control'

import personalState from './modelState/personal'
import forceDownline from './modelState/forceDownline'
import dictionaries from './dictionaries/dictionaries'
import popup from './modelState/popup'
import kzCondition from  './kz-condition/kz-condition'
import kzEntry from './modelState/kz-entry'
import repeatKz from './modelState/repeat-kz'
import home from './model/home'
import entrySelect from './kz-condition/entry-select'
import outBound from './model/outBound'
import pulgin from './model/plugin'
import imgLoop from './modelState/img_loop'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user,
    personalState,
    control,
    forceDownline,
    dictionaries,
    popup,
    kzCondition,
    kzEntry,
    repeatKz,
    home,
    entrySelect,
    outBound,
    pulgin,
    imgLoop,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js